module.exports = __webpack_public_path__ + "static/media/campus-platform-moduleA-img1.5bc7654c.png";